
import React from 'react';
import { Text } from 'grommet';

const CellTitle = ({title, ...props}) => {
    return <Text size="medium" color="dark-4" {...props}>{title}</Text>;
}

export default CellTitle;
